import type { Profile } from './models';

type PlanSubject = Pick<Profile, 'role' | 'subscriptionTier'>;

export function isProvider(p: PlanSubject) {
  return p.role === 'Skill Provider';
}

export function planFeatures(p: PlanSubject) {
  const tier = p.subscriptionTier ?? 'free';
  // With unified plans, all features are based purely on tier regardless of role.
  return {
    provider: isProvider(p),
    founder: !isProvider(p),
    analyticsBasic: ['starter', 'pro', 'enterprise', 'ultimate', 'elite', 'agency'].includes(tier),
    analyticsAdvanced: ['pro', 'enterprise', 'ultimate', 'elite', 'agency'].includes(tier),
    manageTeam: ['enterprise', 'ultimate', 'agency'].includes(tier),
    verifiedBadge: ['enterprise', 'ultimate', 'elite', 'agency'].includes(tier),
    websiteStats: ['pro', 'enterprise', 'ultimate', 'elite', 'agency'].includes(tier),
    teamDigest: ['pro', 'enterprise', 'ultimate', 'elite', 'agency'].includes(tier),
    boardroom: ['enterprise', 'ultimate', 'agency'].includes(tier),
  };
}

export function hasPlanTools(p: PlanSubject) {
  const f = planFeatures(p);
  return f.analyticsBasic || f.manageTeam || f.websiteStats || f.teamDigest || f.boardroom;
}

export function activeProjectCap(p: PlanSubject) {
  const tier = p.subscriptionTier ?? 'free';
  if (tier === 'free') return 5;
  if (tier === 'basic') return 10;
  return Infinity;
}
